var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4C4.02065 4 3.32118 4.28973 2.80546 4.80546C2.28973 5.32118 2 6.02065 2 6.75V8H18V6.75C18 6.02065 17.7103 5.32118 17.1945 4.80546C16.6788 4.28973 15.9793 4 15.25 4H4.75ZM18 9H2V13.25C2 13.9793 2.28973 14.6788 2.80546 15.1945C3.32118 15.7103 4.02065 16 4.75 16H15.25C15.9793 16 16.6788 15.7103 17.1945 15.1945C17.7103 14.6788 18 13.9793 18 13.25V9ZM13.5 13H15.5C15.6326 13 15.7598 13.0527 15.8536 13.1464C15.9473 13.2402 16 13.3674 16 13.5C16 13.6326 15.9473 13.7598 15.8536 13.8536C15.7598 13.9473 15.6326 14 15.5 14H13.5C13.3674 14 13.2402 13.9473 13.1464 13.8536C13.0527 13.7598 13 13.6326 13 13.5C13 13.3674 13.0527 13.2402 13.1464 13.1464C13.2402 13.0527 13.3674 13 13.5 13Z",
    fill: "#CFCFCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/payments.b25cbd130ffc2e211723338032eb6ce5.svg";
export { ForwardRef as ReactComponent };